import moment from 'moment'
import cookie from 'js-cookie'

export const getCompanyDetails = JSON.parse(window.localStorage.getItem('company'))
export const getUserDetails = JSON.parse(window.localStorage.getItem('user'))

export const setUserDetails = (param) => JSON.parse(window.localStorage.setItem('user', param))
export const removeUserDetails = () => {
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('logs')
}

export const getImageUrl = (type = '', fileName, extension = 'png') => {
  const folderPath = type === '' ? '' : `/${type}`
  return `${process.env.REACT_APP_IMAGES_URL}${folderPath}/${fileName}.${extension}`
}

export const htmlEntitiesFunc = (str) => {
  if (typeof str === 'string')
    return String(str)
      .trim()
      .replaceAll('&amp;', '&')
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '"')
      .replaceAll('&nbsp;', ' ')
  return str
}

export const trimFunc = (str) => {
  // THIS WILL REMOVE ALL THE SPACES, ITS IS USED TO COMPARE 2 VALUES BY REMOVING ADDITIONAL SPACES..
  return String(str).trim().replaceAll(' ', '')
}

export const getLogData = (
  ls = 'logs',
  reqIdString = '',
  payloadObject = {},
  responseObject = {}
) => {
  // BELOW ARE THE USE CASES OF THIS FUNCTION
  // const getDataFromLS = getLogData('GetProjects', {companyId: 'e0804536-45e9-11ed-bca4-0a1ea4c5532f', userId: 'f9846ea8-4625-11ed-bca4-0a1ea4c5532f'})
  // const getDataFromLS = getLogData('GetStudies', {projectId: '9e19abd1-559a-11ed-817c-0a1ea4c5532f'})
  // const projectIdValue = getLogData('GetStudies', {}, {StudyId: '11808e09-559b-11ed-817c-0a1ea4c5532f'})[0].ProjectId
  // const headerData = getLogData('GetProjects', {}, {ProjectId: '9e19abd1-559a-11ed-817c-0a1ea4c5532f'})[0]

  if (!window.localStorage.getItem(ls)) {
    return []
  }

  let lsData = JSON.parse(window.localStorage.getItem(ls))
  const payloadObjectLength = Object.keys(payloadObject).length
  const responseObjectLength = Object.keys(responseObject).length

  if (reqIdString !== '') {
    lsData = lsData.filter((d) => d.reqId === reqIdString)
  }

  if (payloadObjectLength) {
    // WIP
    let objectArray = Object.keys(payloadObject)
    lsData = lsData.filter((d) => d.payload[objectArray[0]] === payloadObject[objectArray[0]])
    lsData = [lsData[lsData.length - 1]]
    if (objectArray[1]) {
      lsData = lsData.filter((d) => d.payload[objectArray[1]] === payloadObject[objectArray[1]])
    }
    if (objectArray[2]) {
      lsData = lsData.filter((d) => d.payload[objectArray[2]] === payloadObject[objectArray[2]])
    }
    if (objectArray[3]) {
      lsData = lsData.filter((d) => d.payload[objectArray[3]] === payloadObject[objectArray[3]])
    }
  }

  if (responseObjectLength) {
    // WIP
    let objectArray = Object.keys(responseObject)
    lsData = lsData
      .map((r) => r.response)
      .flat(1)
      .filter((s) => s[objectArray[0]] === responseObject[objectArray[0]])
    lsData = [lsData[lsData.length - 1]]
    if (objectArray[1]) {
      lsData = lsData
        .map((r) => r.response)
        .flat(1)
        .filter((s) => s[objectArray[1]] === responseObject[objectArray[1]])
    }
    if (objectArray[2]) {
      lsData = lsData
        .map((r) => r.response)
        .flat(1)
        .filter((s) => s[objectArray[2]] === responseObject[objectArray[2]])
    }
    if (objectArray[3]) {
      lsData = lsData
        .map((r) => r.response)
        .flat(1)
        .filter((s) => s[objectArray[3]] === responseObject[objectArray[3]])
    }
    return lsData
  }

  return lsData
}

export const setCurrency = (val) => {
  return val.toLocaleString('en-US', { currency: 'USD' })
}

export const timeStampToDate = (str) => {
  return moment(str).format('MMMM DD, YYYY')
}

export const dateDifference = (str) => {
  return moment([]).diff(moment(str), 'days')
}

// use in initiate project
export const isDirty = (values) => {
  return !!(
    values.BrandName ||
    values.CategoryName ||
    values.ProjectFrequency ||
    values.ProjectStartDate ||
    values.ProjectEndDate ||
    values.KeyQuestions ||
    values.TargetSegment ||
    values.BusinessObjective ||
    values.KeyQuestions ||
    values.CompetitorsOption !== 'NA'
  )
}

export const getPxToInch = (px = 0) => {
  return px * 0.0104166667
}

export const removeRememberMe = () => {
  cookie.remove('userEmail')
  cookie.remove('userPassword')
}

export const rememberMe = (data) => {
  cookie.set('userEmail', data.email)
  cookie.set('userPassword', data.password)
}

export const getRememberUser = () => {
  const userName = cookie.get('userEmail')
  const password = cookie.get('userPassword')
  return {
    userName,
    password,
  }
}

export const getObjectAsArray = (data = []) => {
  return Array.isArray(data) ? data : !!Object.keys(data || {})?.length ? [data] : []
}

export const getTabSessionId = () => {
  const storageKey = 'askIaTabSessionId'
  const savedSessionId = window.sessionStorage.getItem(storageKey)

  if (savedSessionId) {
    return savedSessionId
  }

  const newSessionId = `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
  window.sessionStorage.setItem(storageKey, newSessionId)
  return newSessionId
}

export const fakeDelay = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const clearLocalStorageOldData = (maxLen = 100) => {
  window.localStorage.setItem('GetSmallApiLogs', JSON.stringify([]))
  let _lsTotal = 0,
    _xLen,
    _x
  for (_x in localStorage) {
    if (!localStorage.hasOwnProperty(_x)) {
      continue
    }
    _xLen = (localStorage[_x].length + _x.length) * 2
    _lsTotal += _xLen
  }
  const kb = (_lsTotal / 1024).toFixed(2)
  const mb = (kb / 1024).toFixed(2)
  if (mb > 0.7) {
    const localStorageLogs = JSON.parse(window.localStorage.getItem('logs'))
    if (localStorageLogs.length > 10) {
      let finalLocalStorageLogs = []
      for (let i = 0; i < localStorageLogs.length; i++) {
        const drivers = [
          'Drivers',
          'SearchDrivers',
          'DriversAndSubBrands',
          'DriversWithoutSentimentsAndSubBrands',
          'DriversAndRatingImpacts',
        ].includes(localStorageLogs[i].reqId)
        if (!(i > 4 && i < maxLen && !drivers)) {
          finalLocalStorageLogs.push(localStorageLogs[i])
        }
      }
      // window.localStorage.setItem('logssss', JSON.stringify(finalLocalStorageLogs))
      clearLocalStorageOldData(200)
    }
  }
}

export const checkLocalStorageSize = (maxLen = 100) => {
  let _lsTotal = 0,
    _xLen,
    _x
  for (_x in localStorage) {
    if (!localStorage.hasOwnProperty(_x)) {
      continue
    }
    _xLen = (localStorage[_x].length + _x.length) * 2
    _lsTotal += _xLen
  }
  const kb = (_lsTotal / 1024).toFixed(2)
  const mb = (kb / 1024).toFixed(2)
  if (mb > 8) {
    console.log('OMG -- cached cleared', mb)
    const localStorageLogs = JSON.parse(window.localStorage.getItem('logs'))
    if (localStorageLogs.length > 10) {
      let finalLocalStorageLogs = []
      for (let i = 0; i < localStorageLogs.length; i++) {
        const drivers = [
          'Drivers',
          'SearchDrivers',
          'DriversAndSubBrands',
          'DriversWithoutSentimentsAndSubBrands',
          'DriversAndRatingImpacts',
        ].includes(localStorageLogs[i].reqId)
        if (!(i > 10 && i < maxLen && !drivers)) {
          finalLocalStorageLogs.push(localStorageLogs[i])
        }
      }
      // window.localStorage.setItem('logssss', JSON.stringify(finalLocalStorageLogs))
      checkLocalStorageSize(200)
    }
  }
}

export const exportExcel_addPercentage = (value) => {
  // return { value: (value*1), style: { alignment:{horizontal:'right'} } }
  return { value: (value * 1) / 100, style: { numFmt: '0%', alignment: { horizontal: 'right' } } } // WORKING
}

export const exportExcel_addSegments = (obj, showPercent = false) => {
  const array = [
    exportExcel_addPercentage(obj?.PositivePercent || 0),
    exportExcel_addPercentage(obj?.NeutralPercent || 0),
    exportExcel_addPercentage(obj?.MixedPercent || 0),
    exportExcel_addPercentage(obj?.NegativePercent || 0),
  ]
  if (showPercent) {
    array.push(exportExcel_addPercentage(obj?.Percent || 0))
  }
  return array
}

export const rteRemovingStyleFromTable = (str) => {
  return str
    .replaceAll('<td style="', '_style="')
    .replaceAll('<tr style="', '_style="')
    .replaceAll('font-size: 8pt;', 'font-size: 10px;')
    .replaceAll('font-size: 10pt;', 'font-size: 13px;')
    .replaceAll('font-size: 12pt;', 'font-size: 16px;')
    .replaceAll('font-size: 14pt;', 'font-size: 18px;')
    .replaceAll('font-size: 18pt;', 'font-size: 24px;')
    .replaceAll('font-size: 24pt;', 'font-size: 32px;')
    .replaceAll('font-size: 36pt;', 'font-size: 48px;')
}

export const removeSpecialCharFromLhs = (str) => {
  // return str.replaceAll(" ", "").replaceAll(":", "").replaceAll(".", "").replaceAll("/", "").replaceAll("'", "")
  // return str.replace(/[ :.//']/g, "")
  return str.replace(/[^a-zA-Z0-9]/g, '')
}

export const removeCharFromLhsAndTabs = (str) => {
  return str.replace(/[^a-zA-Z0-9]/g, '')
  // return str.replaceAll("?", "").replaceAll(" ", "").replaceAll(":", "").replaceAll(".", "").replaceAll("/", "").replaceAll("'", "").replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replace(/\//g, '')
  // return str.replace(/[ :.//']/g, "")
}

export const removeAllKeepNumber = (str) => {
  return Number((str+'').replace(/[^0-9.]/g, ''))
}

export const exportToPPT_tableCss = `
    &.exportToPPT, & .exportToPPT {
        .liLi { list-style: circle; margin-left: 24px; }
        .theadTr { background:#f1f1f1;}
        .theadTr td, .tbodyTr td { padding:10px; border:1px #E0E0E0 solid;}
        .tbodyTr td ul{ margin-left:10px;}
    }
`
export const tableCss = `
    & .liLi { list-style: circle; margin-left: 24px; }
    & table { width: 100%; border-collapse:collapse; border:1px; border-color: #E0E0E052;}
    & table td { padding:10px;  font-weight: 400; font-size: 14px; vertical-align: text-bottom; border:1px #E0E0E0 solid; }
    & thead { background:#f1f1f1;}
    & thead td { font-weight: 600; color:#000; }
    // & thead td, & tbody td { padding:10px; border:1px #E0E0E0 solid;}
    & tbody td ul{ margin-left:20px;}
`
export const ulLiCss = `
    & ul{ list-style-type:disc; margin-left:20px !important; padding-left:0 !important;}
    & ul li{ padding-bottom:2px;}
    & ul ul{ list-style-type:circle;}
    & ul ul ul{ list-style-type:square;}
    & ul ul ul ul{ list-style-type:disc;}
    & ul ul ul ul ul{ list-style-type:circle;}
    & ul ul ul ul ul ul{ list-style-type:square;}
`
export const olLiCss = `
    & ol{ margin-left:20px !important; padding-left:0 !important;}
    & ol li{ padding-bottom:2px;}
    & ol ol{ list-style-type:circle;}
    & ol ol ol{ list-style-type:square;}
    & ol ol ol ol{ list-style-type:disc;}
`
export const ulLiCssRecommendation = `
    & ul{ list-style-type:disc; margin-left:20px !important; padding-left:0 !important;}
    & ul li{ padding-bottom:2px;}
    & ul ul{ list-style-type:disc;}
    & ul ul ul{ list-style-type:circle;}
    & ul ul ul ul{ list-style-type:square;}
    & ul ul ul ul ul{ list-style-type:disc;}
    & ul ul ul ul ul ul{ list-style-type:circle;}
    & ul ul ul ul ul ul ul{ list-style-type:square;}
`
export const olLiCssRecommendation = `
    & ol{ list-style-type:disc; margin-left:20px !important; padding-left:0 !important;}
    & ol li{ padding-bottom:2px;}
    & ol ol{ list-style-type:disc;}
    & ol ol ol{ list-style-type:circle;}
    & ol ol ol ol{ list-style-type:square;}
`

export const charWidthFunc = (str) => {
  const setValues = [4, 6, 8, 10, 12]

  const set_0 = [
    // 4
    'f',
    'i',
    'j',
    'l',
    'r',
    't',
    'I',
    '',
    '',
    '',
    '|',
    '!',
    ' ',
    ',',
    '.',
  ]

  const set_1 = [
    // 6
    'k',
    's',
    'v',
    'x',
    'y',
    'z',
    'E',
    'F',
    'J',
    'L',
    'P',
    'Z',
    '&',
    '#',
    '\\',
  ]

  const set_2 = [
    // 8
    'a',
    'b',
    'c',
    'd',
    'e',
    'g',
    'h',
    'n',
    'o',
    'p',
    'q',
    'u',
    'A',
    'B',
    'D',
    'H',
    'K',
    'N',
    'R',
    'S',
    'T',
    'U',
    'V',
    'X',
    'Y',
    '$',
  ]

  const set_3 = [
    // 10
    'C',
    'G',
    'M',
    'O',
    'Q',
  ]

  const set_4 = [
    // 12
    'm',
    'w',
    'W',
    '@',
  ]

  let length = 0
  for (let i = 0; i < str.length; i++) {
    if (set_0.includes(str.charAt(i))) {
      length += setValues[0]
    } else if (set_1.includes(str.charAt(i))) {
      length += setValues[1]
    } else if (set_2.includes(str.charAt(i))) {
      length += setValues[2]
    } else if (set_3.includes(str.charAt(i))) {
      length += setValues[3]
    } else if (set_4.includes(str.charAt(i))) {
      length += setValues[4]
    } else {
      length += setValues[4]
    }
  }

  return length
}

export const setToAscendingOrder = (array) => {
  return array.sort(function (a, b) {
    if (a < b) {
      return -1
    }
    if (a > b) {
      return 1
    }
    return 0
  })
}

export const sortByKey = (array, key, direction = true) => {
  if (array?.[0]) {
    const isNumber = removeHtmlTags(array[0][key] + '', 'removePercent') >= 0
    if (isNumber) {
      // IF THIS IS KEY IS A NUMBER
      if (direction) {
        // Ascending Order by `id`
        return array.sort(
          (a, b) =>
            removeHtmlTags(a[key] + '', 'removePercent') -
            removeHtmlTags(b[key] + '', 'removePercent')
        )
      }
      // Descending Order by `id`
      return array.sort(
        (a, b) =>
          removeHtmlTags(b[key] + '', 'removePercent') -
          removeHtmlTags(a[key] + '', 'removePercent')
      )
    } else {
      // IF THIS IS KEY IS A STRING
      if (direction) {
        // Ascending Order by `name`
        return array.sort((a, b) =>
          String(removeHtmlTags(a[key] + '')).localeCompare(String(removeHtmlTags(b[key] + '')))
        )
      }
      // Descending Order by `name`
      return array.sort((a, b) =>
        String(removeHtmlTags(b[key] + '')).localeCompare(String(removeHtmlTags(a[key] + '')))
      )
    }
  }
  return array
}

export const getDistinctValues = (myArray, key = null) => {
  if (key) {
    return Array.from(new Map(myArray.map((item) => [item[key], item])).values())
  } else {
    return [...new Set(myArray)]
  }
}

export const removeAttributes = (htmlString, attributesToRemove) => {
  // Parse the HTML string into a DOM object
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  // Select all elements in the document
  const allElements = doc.body.querySelectorAll('*')

  // Iterate over all elements and remove the specified attributes
  allElements.forEach((element) => {
    attributesToRemove.forEach((attr) => {
      if (element.hasAttribute(attr)) {
        element.removeAttribute(attr)
      }
    })
  })

  // Serialize the DOM back into an HTML string
  return doc.body.innerHTML
}

export const decodeAndStrip = (htmlEncoded) => {
  const textarea = document.createElement('textarea');
  document.body.appendChild(textarea);   // temporarily add

  textarea.innerHTML = htmlEncoded;
  const decoded = textarea.value;

  document.body.removeChild(textarea);   // immediately remove

  return decoded.replace(/<[^>]*>/g, '');
}

export const removeUnwantedTagsAndAttributes = (htmlString) => {
  // THIS IS ONLY FOR PPT, THIS WILL REMOVE ALL ATTRIBUTE & TAGS LIKE : A, B, STRONG, I, EM, SPAN
  const str = removeAttributes(htmlString, ['id', 'class', 'style', 'href', 'target'])
  const finalStr = str
    .replace(/<\/?a[^>]*>/g, '')
    .replace(/<\/?b[^>]*>/g, '')
    .replace(/<\/?strong[^>]*>/g, '')
    .replace(/<\/?i[^>]*>/g, '')
    .replace(/<\/?em[^>]*>/g, '')
    .replace(/<\/?span[^>]*>/g, '')
    .replace(/<\/?s[^>]*>/g, '')

  return finalStr === '' ? '-' : finalStr
}

export const  decodeSpecialChars = (text) => {
  const replacements = {
    '&nbsp;': ' ',
    '&ensp;': ' ',
    '&emsp;': ' ',
    '&thinsp;': ' ',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&apos;': "'",
    '&rsquo;': "'",
    '&lsquo;': "'",
    '&rdquo;': '"',
    '&ldquo;': '"',
    '&ndash;': '-',
    '&mdash;': '--',
    '&hellip;': '...',
    '&copy;': '©',
    '&reg;': '®',
    '&trade;': '™',
    '&bull;': '•',
    '&deg;': '°'
  };

  return text.replace(
    /&nbsp;|&ensp;|&emsp;|&thinsp;|&amp;|&lt;|&gt;|&quot;|&#39;|&apos;|&rsquo;|&lsquo;|&rdquo;|&ldquo;|&ndash;|&mdash;|&hellip;|&copy;|&reg;|&trade;|&bull;|&deg;/g,
    match => replacements[match]
  );
}

export const removeHtmlTags = (str, type = '') => {
  // const str = removeAttributes(htmlString, ['id', 'class', 'style', 'href', 'target']);

  if (type === 'replaceSpacing') {
    // USED IN EXCEL EXPORT
    return str.replace(/<\/?[^>]+(>|$)/g, '')
    // return str.replaceAll('</li>', '\n').replace(/<\/?[^>]+(>|$)/g, "")
  }
  if (type === 'removeSpacing') {
    return str.replace(/<\/?[^>]+(>|$)/g, '').replaceAll(' ', '')
  }
  if (type === 'removePercent') {
    return Number(
      str
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replaceAll('%', '')
        .replaceAll(',', '')
        .replaceAll(' ', '')
        .replaceAll('K', '')
        .replaceAll('M', '') * 1
    )
  }
  if (type === 'convertToNumber') {
    // HERE IT IS CONFIRMED IT WILL BE A NUMBER
    const newStr = str.replace(/<\/?[^>]+(>|$)/g, '').toUpperCase()
    const hasPercentSign = newStr.match('%')
    const hasCommaSeparatedAmount = newStr.match(',')
    const hasAmountInK = newStr.match('K')
    const hasAmountInM = newStr.match('M')
    const hasAmountInB = newStr.match('B')
    if (hasPercentSign) return Number(newStr.replaceAll('%', '') * 1)
    if (hasCommaSeparatedAmount) return Number(newStr.replaceAll(',', '') * 1)
    if (hasAmountInK) return Number(newStr.replaceAll('K', '') * 1) * 1000
    if (hasAmountInM) return Number(newStr.replaceAll('M', '') * 1) * 1000000
    if (hasAmountInB) return Number(newStr.replaceAll('B', '') * 1) * 1000000000
  }
  if (type === 'removeNewLine') {
    // return str.replace(/<\/?[^>]+(>|$)/g, "").replace(/[\r\n]/g, '')
    return str.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
  }
  return str.replace(/<\/?[^>]+(>|$)/g, '')
}

export const convertToNumber = (value) => {
  if (typeof value !== 'string') return value // Return the value if it's not a string

  const suffixes = { K: 1000, M: 1000000, B: 1000000000 } // Define suffix multipliers
  const suffix = value.slice(-1).toUpperCase() // Extract the last character (suffix)
  const number = parseFloat(value.slice(0, -1)) // Extract the numeric part

  return suffixes[suffix] ? number * suffixes[suffix] : parseFloat(value)
}

export const formatIfIsPrice = (val) => {
  const checkIfPrice = (str) => {
    const v = removeHtmlTags(str, 'removeSpacing')
    if (['m', 'k'].includes(v.slice(-1).toLowerCase()) && v.match(/[a-zA-Z]/g).length === 1) {
      return true
    }
    return false
  }
  if (checkIfPrice(val)) {
    const v1 = removeHtmlTags(val, 'removeSpacing')
    const v2 = convertToNumber(v1)
    return val
  } else {
    return val
  }

  // const value = removeHtmlTags(val).replaceAll(' ','').replaceAll('.','').replaceAll('M','').replaceAll('K','')+''
  // if( Number(value) >= 0 ){
  //     const finalValue = convertToNumber(removeHtmlTags(val))
  //     return finalValue
  // } else {
  //     return val
  // }
}

export const scrollByPxFromCurrentPosition = () => {
  if (document.querySelector('.rhsContent')) {
    document.querySelector('.rhsContent').scrollTo({
      top: document.querySelector('.rhsContent').scrollTop + 1,
    })
  }
}

export const sortingDataForProgressionTabList = (array) => {
  // NOTE THIS IS ONLY FOR PROGRESSION TAB LIST, SHOULD NOT BE USED SOME WHERE ELSE ..

  const monthArray = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ]
  const shortMonthArray = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
    'dec-jan', 'jan-feb', 'feb-mar', 'mar-apr', 'apr-may', 'may-jun', 'jun-jul', 'jul-aug', 'aug-sep', 'sep-oct', 'oct-nov', 'nov-dec',
    
  ]
  const phaseArray = ['phase1', 'phase2', 'phase3', 'phase4']
  const periodT = ['t1', 't2', 't3', 't4']
  const periodQ = ['q1', 'q2', 'q3', 'q4', 'h1', 'h2']
  const periodH = ['h1', 'h2']
  const tempData = array.map((d) => {
    const fullDate = d.toLowerCase().split(' ')
    const monthIndex = monthArray.indexOf(fullDate[0])
    const shortMonthIndex = shortMonthArray.indexOf(fullDate[0])
    const fullPhase = d.toLowerCase().split(' fy')
    const phaseIndex = phaseArray.indexOf(fullPhase[0].replaceAll(' ', ''))
    const fullPeriodT = d.toLowerCase().split(' ')
    const periodTIndex = periodT.indexOf(fullPeriodT[0])
    const fullPeriodQ = d.toLowerCase().split(' ')
    const periodQIndex = periodQ.indexOf(fullPeriodQ[0])
    const fullPeriodH = d.toLowerCase().split(' ')
    const periodHIndex = periodH.indexOf(fullPeriodH[0])

    if (monthIndex !== -1) {
      const month = monthIndex >= 10 ? monthIndex : `0${monthIndex}`
      return { isDate: true, str: d, sortKey: `${fullDate[1]}-${month}` }
    } else if (shortMonthIndex !== -1) {
      const month = monthIndex >= 10 ? monthIndex : `0${monthIndex}`
      return { isDate: true, str: d, sortKey: `${fullDate[1]}-${month}` }
    } else if (phaseIndex !== -1) {
      return {
        isDate: true,
        str: d,
        sortKey: `${fullPhase[1]}-${fullPhase[0].replace('phase ', '')}`,
      }
    } else if (periodTIndex !== -1) {
      return {
        isDate: true,
        str: d,
        sortKey: `${fullPeriodT[1]}-${fullPeriodT[0].replace('t', '')}`,
      }
    } else if (periodQIndex !== -1) {
      return {
        isDate: true,
        str: d,
        sortKey: `${fullPeriodQ[1]}-${fullPeriodQ[0].replace('q', '')}`,
      }
    } else if (periodHIndex !== -1) {
      return {
        isDate: true,
        str: d,
        sortKey: `${fullPeriodH[1]}-${fullPeriodH[0].replace('h', '')}`,
      }
    }

    return { isDate: false, str: d, sortKey: d.toLowerCase() }
  })

  // Determine if the array is purely strings based on initial data
  const isString = tempData.every((item) => !item.isDate)

  // Sort and map back to the original strings
  return sortByKey(tempData, 'sortKey', isString).map((d) => d.str)
}

export const showCustomDevTool = (ls, list) => {
  const url = window.location.hostname.replace('www.', '').replace('.com', '').replace(':8080', '')
  if (['localhost', 'staging-ia.mavenmagnet'].includes(url)) {
    const localStorage = window.localStorage.getItem(ls)
    if (localStorage && ls === 'dev') {
      return true
    }
    if (localStorage && ls === 'dev_report' && list?.InsightsElementId) {
      if (JSON.parse(localStorage).includes(list.InsightsElementType || list.InsightsElementId)) {
        return JSON.parse(localStorage)
      }
      return false
    } else if (localStorage && ls === 'dev_report') {
      return true
    }
    return false
  }
  return false
}

export const removeCSVLocalStorage = (str) => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(str)) {
      localStorage.removeItem(key)
    }
  })
}

export const toSentenceCase = (str) => {
  return str
    .toLowerCase() // Convert entire string to lowercase first
    .replace(/(^\s*\w|[.!?]\s*\w)/g, (match) => match.toUpperCase()) // Capitalize first letter after punctuation
}

export const getProgressionArray = (d, type = 'card') => {
  let array = []
  if (
    [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ].includes((d[0].PeriodName.split(' ')[0]).toLowerCase())
  ) {
    array = ['3M', '6M', '12M']
  } else if (
    ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec', 
      'dec-jan', 'jan-feb', 'feb-mar', 'mar-apr', 'apr-may', 'may-jun', 'jun-jul', 'jul-aug', 'aug-sep', 'sep-oct', 'oct-nov', 'nov-dec',
    ].includes(
      (d[0].PeriodName.split(' ')[0]).toLowerCase()
    )
  ) {
    array = ['3M', '6M', '12M']
  } else if (['Q1', 'Q2', 'Q3', 'Q4'].includes(d[0].PeriodName.split(' ')[0])) {
    array = ['3Q', '6Q', '12Q']
  } else if (
    ['Phase 1', 'Phase 2', 'Phase 3', 'Phase 4'].includes(d[0].PeriodName.split(' FY')[0])
  ) {
    array = ['3P', '6P', '12P']
  } else if (['T1', 'T2', 'T3'].includes(d[0].PeriodName.split(' 20')[0])) {
    array = ['3T', '6T', '12T']
  } else if (['H1', 'H2'].includes(d[0].PeriodName.split(' ')[0])) {
    array = ['3H', '6H', '12H']
  }

  if (d.length <= 6) {
    array = array.splice(0, 2)
  }
  if (d.length <= 3) {
    array = array.splice(0, 1)
  }
  if (type === 'popup' && d.length > 12) array.push('MAX')

  const settings = [
    { minWidth: 225, barWidth: 22, barsInGraph: 3 },
    { minWidth: 280, barWidth: 20, barsInGraph: 6 },
    { minWidth: 460, barWidth: 18, barsInGraph: 12 },
    // { minWidth: 560, barWidth:18, barsInGraph: 15 },
    { minWidth: 560, barWidth: 18, barsInGraph: 50 },
  ]
  const finalArray = array.map((str, i) => {
    return { ...settings[i], title: str }
  })
  return finalArray
}

export const addZero = (num) => {
  return num > 0 && num < 10 ? '0' + num : num
}

export const generateStringToHtmlForAskIA = (str) => {
  if (str.indexOf('html') != -1 && str.indexOf('<div>') != -1) {
    const finalStr = [
      str
        .replaceAll('html', '')
        .replaceAll('\n', '.')
        .replaceAll('..', '.').replaceAll(' .', '.').replaceAll('>.', '>').replaceAll('.<', '<')
        .replaceAll('<div>', '').replaceAll('</div>', '')
        .replaceAll('`', '').trim()
    ]
    return finalStr
  } else {
    const convertStrToArrayFunc = (str2) => {
      const parts = str2.split('**')
      const str3 = []
      const str4 = []

      // ADDING BOLD
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim()
        // Even index: normal text (not bold), Odd index: bold text
        if (i % 2 === 0) {
          if (part) str3.push(`<span>${part}</span>`) // skip empty strings
        } else {
          str3.push(`<b>${part}</b>`)
        }
      }

      // ADDING ITALICS
      for (const segment of str3) {
        if (segment.includes(' *') && segment.includes('* ')) {
          const [beforeItalic, rest] = segment.split(' *')
          const [italicText, afterItalic] = rest.split('* ')

          str4.push(`${beforeItalic}</span>`)
          str4.push(`<i>${italicText}</i>`)
          str4.push(`<span>${afterItalic}`)
        } else {
          str4.push(segment)
        }
      }
      if (
        str4?.length === 1 &&
        str4?.[0]?.length > 16 &&
        str4[0].includes('<span>*') &&
        str4[0].includes('*</span>')
      ) {
        const count = str4[0].split('').filter((char) => char === '*').length
        if (count > 1)
          str4[0] = str4[0].replace('<span>*', '<span><i>').replace('*</span>', '</i></span>')
      }

      const str5 = str4.map((d) => d.replace(/<(b|i|span|li)>\s*<\/\1>/g, ''))
      str5.push('')

      return str5
    }

    const str1 = str
    const str1_ = `
      Here's a comparison of Amazon and Roku based on the provided data:
      \n\n**Differences:**\n\n
      *   **Monetization Tools:** Roku has a 3% positive sentiment, while Amazon has a 6% negative sentiment\n 
      *   **Code Compatibility:** Roku has a 6% negative sentiment, while Amazon has a 10% positive sentiment\n 
          *_   **Software Development Kit:** Roku has a 10% negative sentiment, while Amazon has a 4% positive sentiment\n 
          *_   **Coding:** Roku has a 29% negative sentiment, while Amazon has a 4% negative sentiment\n **Similarities:**\n\n
      *   **Console (Customer Support):** Roku has a 12% negative sentiment, and Amazon has a 15% negative sentiment\n
      *   **Communication (Customer Support):** Roku has a 3% positive sentiment, and Amazon has a 6% positive sentiment.\n
      \n\n**Differences:**\n\n
      *   **Code Compatibility:** Roku has a 6% negative sentiment, while Amazon has a 10% positive sentiment\n 
          *_   **Monetization Tools:** Roku has a 3% positive sentiment, while Amazon has a 6% negative sentiment\n 
          *_   **Software Development Kit:** Roku has a 10% negative sentiment, while Amazon has a 4% positive sentiment\n 
          *_   **Coding:** Roku has a 29% negative sentiment, while Amazon has a 4% negative sentiment\n **Similarities:**\n\n
          *_   **Console (Customer Support):** Roku has a 12% negative sentiment, and Amazon has a 15% negative sentiment\n
          *_   **Communication (Customer Support):** Roku has a 3% positive sentiment, and Amazon has a 6% positive sentiment.\n
    `

    const lines = str1.split('\n')
    
    function addBlankLines(arr) {
      const result = [];
      arr.forEach(row => {
        // add the row
        result.push(row);
        // if this row is a reason (rows starting with "<span>1.</span>", "2.", "3.")
        if (row[0] && row[0].match(/^<span>[123]\.<\/span>/)) {
          // insert a blank row after it
          result.push(['']);
        }
      });
      return result;
    }

    const strToArray = lines.map((line) => {
      return convertStrToArrayFunc(line)
    })
    const strToArray2 = addBlankLines(strToArray)

    const arrayToString = strToArray2.map((arr) => {
      if (arr.length === 0) {
        return '<br>'
      } else if (arr.length === 1 && arr[0] === '') {
        return '<br>'
      } else if (arr.length === 1 && arr[0].indexOf('</b>') !== -1) {
        return `<p>${arr[0]}</p>`
      } else if (arr.length === 1 && arr[0].indexOf('</i>') !== -1) {
        return `<p>${arr[0]}</p>`
      } else if (arr.length === 1 && arr[0].indexOf('</span>') !== -1) {
        let tag = 'p'
        let className = ''
        if (arr[0].indexOf('#') !== -1) {
          tag = 'h1'
          className = ''
        } else if (arr[0].indexOf('##') !== -1) {
          tag = 'h2'
          className = ''
        } else if (arr[0].indexOf('###') !== -1) {
          tag = 'h3'
          className = ''
        } else if (arr[0].indexOf('* ') !== -1) {
          tag = 'li'
          className = 'level1'
        } else if (arr[0].indexOf('*_ ') !== -1) {
          tag = 'li'
          className = 'level2'
        }

        const clsAttr = className ? ` class="${className}"` : ''
        return `<${tag}${clsAttr}>${arr[0].replace('#', '').replace('##', '').replace('###', '').replace('* ', '').replace('*_ ', '').replace('<span>', '').replace('</span>', '')}</${tag}>`
      }

      if (arr[0].replaceAll(' ', '') === '<span>*</span>') {
        // LI
        return `<li class="level1">${arr.join(' ').replace('<span>*</span>', '').replace('<span>* </span>', '')}</li>`
      } else if (arr[0].replaceAll(' ', '') === '<span>*_</span>') {
        // LI LI
        return `<li class="level2">${arr.join(' ').replace('<span>*_</span>', '').replace('<span>*_ </span>', '')}</li>`
      } else if (arr[0].replaceAll(' ', '') === '<span>#</span>') {
        // H1
        return `<h1>${arr.join(' ').replace('<span>#</span>', '').replace('#', '')}</h1>`
      } else if (arr[0].replaceAll(' ', '') === '<span>##</span>') {
        // H2
        return `<h2>${arr.join(' ').replace('<span>##</span>', '').replace('##', '')}</h2>`
      } else if (arr[0].replaceAll(' ', '') === '<span>###</span>') {
        // H3
        return `<h3>${arr.join(' ').replace('<span>###</span>', '').replace('###', '')}</h3>`
      }

      // BY THIS TIME THERE ARR SHOULD BE A STRING AND IF NOT THEN HAVE TO CONVERT IT!!
      if (Array.isArray(arr)) {
        arr = arr.join(' ')
      }

      return arr
    })

    const arrayToString2 = arrayToString
      // .filter(f => !['<br>', ''].includes(f))
      .filter(f => f?.[0] !== '')
      .map(d => {
        const str = d.replaceAll(' ', '')
        if (str.indexOf('<liclass="level1">Insight:') !== -1) {
          return d.replace('<li class="level1">', '<li class="level2">')
        }
        if (str.indexOf('<p>Insight:') !== -1) {
          return d.replace('</p>', '</li>').replace('<p>', '<li class="level1">')
        }
        return d.replaceAll('undefined', '')
      })

    return arrayToString2
  }
}

export const smoothScrollToTarget = (
  type,
  targetId,
  duration = 600,
  parentId = null,
  stickyContainerId = null
) => {
  const duration2 = duration
  const target = document.getElementById(targetId)
  const parent = parentId ? document.getElementById(parentId) : window
  const sticky = stickyContainerId ? document.getElementById(stickyContainerId) : null
  const breadCrumbHeight = 56

  if (!target || !parent) return

  const isWindow = parent === window

  // Sticky height adjustment
  let stickyHeight = 0
  if (sticky) {
    stickyHeight = sticky.offsetHeight - 10

    // Check if sticky container contains an h4 and subtract its height
    const h4 = sticky.querySelector('h4')
    if (h4) {
      stickyHeight -= h4.offsetHeight
    }
  }

  if (type === 'lhs' && sticky) {
    stickyHeight = stickyHeight - 97
  }

  const targetOffset = isWindow
    ? target.getBoundingClientRect().top + window.pageYOffset - stickyHeight
    : target.offsetTop - parent.offsetTop - stickyHeight

  const startScroll = isWindow ? window.pageYOffset : parent.scrollTop
  const distance = targetOffset - startScroll

  let startTime = null

  function animation(currentTime) {
    if (!startTime) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const run = easeInOutQuad(timeElapsed, startScroll, distance, duration2)

    if (isWindow) {
      window.scrollTo(0, run)
    } else {
      // parent.scrollTop = run;
      parent.scrollTo(0, run)
    }

    if (timeElapsed < duration2) {
      requestAnimationFrame(animation)
    }
  }

  // Easing function
  function easeInOutQuad(t, b, c, d) {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t + b
    t--
    return (-c / 2) * (t * (t - 2) - 1) + b
  }

  requestAnimationFrame(animation)
}

export const getPageScrollLength = (id) => {
  const activeLhsLink = document.querySelector('.lhsLevel2 a.active')?.getAttribute('data-target')
  let distance = 0
  let direction = 'down'
  let length = 4

  if(activeLhsLink){
    const getCurrentPosition = document.querySelector('#' + activeLhsLink).getBoundingClientRect().top
    const getTargetPosition = document.querySelector('#' + id).getBoundingClientRect().top

    if (getTargetPosition > getCurrentPosition) {
      distance = getTargetPosition - getCurrentPosition
    } else if (getCurrentPosition > getTargetPosition) {
      distance = getCurrentPosition - getTargetPosition
      direction = 'up'
    }

    if (distance < 500) {
      length = 1
    } else if (distance < 6000) {
      length = 1
    } else if (distance < 10000) {
      length = 2
    } else if (distance < 15000) {
      length = 3
    }
  }
  return { length: length, distance: distance, direction: direction, id: id }
}


export const getSnapshotUpdatedJson_AddRowColFunc = (array1) => {
  // CODE USED ONLY IN SNAPSHOT COMPONENT
      /*
      const array1 = [
          {orderBy: 0, id: 2, height: 1, width: 1},
          {orderBy: 1, id: 3, height: 1, width: 1},
          {orderBy: 2, id: 4, height: 1, width: 1},
          {orderBy: 3, id: 1, height: 1, width: 1},
          {orderBy: 4, id: 9, height: 1, width: 2},
          {orderBy: 5, id: 8, height: 2, width: 1},
          {orderBy: 6, id: 5, height: 1, width: 1},
          {orderBy: 7, id: 6, height: 1, width: 1},
          {orderBy: 8, id: 7, height: 1, width: 1},
      ];

      const result = 
      [
          { orderBy: 0, id: 2, height: 1, width: 1, row: 1, col: 1 },
          { orderBy: 1, id: 3, height: 1, width: 1, row: 1, col: 2 },
          { orderBy: 2, id: 4, height: 1, width: 1, row: 1, col: 3 },
          { orderBy: 3, id: 1, height: 1, width: 1, row: 1, col: 4 },
          { orderBy: 4, id: 9, height: 1, width: 2, row: 2, col: 1 },
          { orderBy: 5, id: 8, height: 2, width: 1, row: 2, col: 3 },
          { orderBy: 6, id: 5, height: 1, width: 1, row: 2, col: 4 },
          { orderBy: 7, id: 6, height: 1, width: 1, row: 3, col: 1 },
          { orderBy: 8, id: 7, height: 1, width: 1, row: 3, col: 2 }
      ]

      */
      const columns = 4;
      const grid = []; // Tracks occupied cells: grid[row][col]
      const result = [];

      function isSpaceFree(row, col, height, width) {
          for (let r = row; r < row + height; r++) {
          if (!grid[r]) grid[r] = [];
          for (let c = col; c < col + width; c++) {
              if (grid[r][c]) return false;
          }
          }
          return true;
      }

      function occupySpace(row, col, height, width) {
          for (let r = row; r < row + height; r++) {
          if (!grid[r]) grid[r] = [];
          for (let c = col; c < col + width; c++) {
              grid[r][c] = true;
          }
          }
      }

      array1.forEach(item => {
          const { width, height } = item;
          let placed = false;

          for (let row = 0; !placed; row++) {
          for (let col = 0; col <= columns - width; col++) {
              if (isSpaceFree(row, col, height, width)) {
              occupySpace(row, col, height, width);
              result.push({
                  ...item,
                  row: row + 1,
                  col: col + 1
              });
              placed = true;
              break;
              }
          }
          }
      })
      return result
}

export const generateSnapshotWidgetRowsAndColsFunc = (array, type='edit', wrapperWidth) => {
  // CODE USED ONLY IN SNAPSHOT COMPONENT
  let colW = (wrapperWidth-64)/4 // 245
  let colH = type === 'view' ? 190 : 80
  if(type === 'view'){
    colW = (wrapperWidth)/4 // 245
    colH = 190
  }
  
  const getData = (array) => {
    const boxes = array.map(d => ({...d, w: d.width*colW, h: d.height*colH}))
    
    let chunkSize = 4;
    const chunkedBoxes = [];

    for (let i = 0; i < boxes.length; i+=chunkSize) {
        let counter = 0
        let totalW = 0

        for(let j=i; j<i+4; j++){
            const w = boxes[j]?.w
            if(w > 0 && totalW < (colW*4)){
                boxes[j]['colSpan'] = (w > colW) ? w/colW : 1
                totalW += w
                counter++
            } else {
                break
            }
        }
        chunkSize = counter

        if(chunkedBoxes.length > 0){
            const previousArrayLength = chunkedBoxes[ chunkedBoxes.length-1 ].length
            for(let k=(i-previousArrayLength); k<i; k++){
                const h = boxes[k]?.h || 0
                if(h === colH*2){
                  boxes[k]['rowspan'] = 2
                  chunkSize = chunkSize - 1
                } else if(h === colH*3){
                  boxes[k]['rowspan'] = 3
                  chunkSize = chunkSize - 1
                  // console.log('NEED TO CHECK WITH ROWSPAN 3')
                } else {
                  boxes[k]['rowspan'] = 1
                }
            }
        }
        const chunk = boxes.slice(i, i + chunkSize);
        chunkedBoxes.push(chunk);
    }
    return chunkedBoxes
  }
  ////////////////////////////////////////////////
  const data = getData(array)
  const object = { maxCols:4 }

  data.forEach(row => {
    let count = 0
    row.forEach(cell => count += (cell.colSpan || 1))
    object.maxCols = Math.max(object.maxCols, count)
  })

  object.gridTemplateColumns = `repeat(${object.maxCols}, auto)`
  object.data = []

  data.forEach((row, rowIndex) => {
    let colIndex = 1;
    const rowArray = []
    row.forEach(cell => {
      const finalCell = {
        ...cell,
        className: 'grid-cell',
        textContent: `orderBy: ${cell.orderBy}`,
        style: {
          height : cell.height+'px',
          gridRowStart : rowIndex + 1,
          gridColumnStart : colIndex
        }
      }
      if (finalCell.rowspan) { finalCell.style.gridRowEnd = `span ${finalCell.rowspan}` }
      if (finalCell.colSpan) { finalCell.style.gridColumnEnd = `span ${finalCell.colSpan}` }
      rowArray.push(finalCell)
    })

    object.data.push(rowArray)
  })

  //
  if(array.length !== object.data.flat(2).length){
    // DANGER ISSUE GOT FIXED. ONDELETING OR MOVEING OR ACTION IT WAS GENERATING DUPLICATES OF ANY OBJECT ...
    const idArray = showDuplicateObjects(object.data.flat(2), 'guid') // ['aaacc11d-fa2c-42ff-86f8-a74cc7ac746e']; // guids to check
    const seenCount = {}; // to track how many times a guid has occurred

    const newArray = object.data.map(row => {
      return row.filter(item => {
        if (!item?.guid) return true; // skip if item is null/empty
        if (!idArray.includes(item.guid)) return true; // not in idArray, keep it
        seenCount[item.guid] = (seenCount[item.guid] || 0) + 1;
        // keep only the first occurrence
        return seenCount[item.guid] <= 1;
      });
    });
    object.data = newArray
  }

  return object
  // setWidgetObject(object)
  // addRowNumberFunc()
}

const showDuplicateObjects = (array, key) => {
  const counts = {};
  array.forEach(item => { counts[item[key]] = (counts[item[key]] || 0) + 1 })
  return Object.keys(counts).filter(key => counts[key] > 1) //duplicates
}

export const customScrollBarCss = `
  overflow: auto;
  &::scrollbar-button, &::-webkit-scrollbar-button {
    display: none;
  }
  &::scrollbar, &::-webkit-scrollbar {
    width: 8px;
  }
  &::scrollbar-track, &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 4px;
  }
  &::scrollbar-thumb, &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
    border: 2px solid #f0f0f0;
  }
  &::scrollbar-thumb:hover, &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
  scrollbar-width: thin;
  scrollbar-color: #888 #f0f0f0;
`


export const hexToRgba = (hex, opacity = 100) => {
  let r = 0, g = 0, b = 0;
  if (hex?.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else if (hex?.length === 7) {
    r = parseInt(hex.substring(1, 3), 16);
    g = parseInt(hex.substring(3, 5), 16);
    b = parseInt(hex.substring(5, 7), 16);
  }
  return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`;
};


export const getTextHeight = (text, width, font) => {
  // Create a hidden div
  const div = document.createElement('div');
  div.style.position = 'absolute';
  div.style.visibility = 'hidden';
  div.style.width = width + 'px';
  div.style.font = font; 
  div.style.whiteSpace = 'normal';
  div.style.lineHeight = 'normal';
  div.style.padding = '0';
  div.style.margin = '0';
  
  div.textContent = text;
  document.body.appendChild(div);
  
  const height = div.offsetHeight;
  
  document.body.removeChild(div);
  
  return height;
}


